export const Theme = {
    device: {
        mobile: 767,
        tablet: 1023,
    },
    text: {
        default: {
            fontSize: "24px",
            fontFamily: `'Pretendard', sans-serif`,
            letterSpacing: "0px",
            lineHeight: "normal",
            fontWeight: "normal",
            fontColor: "#171A1C",
            margin: "0px",
        },
        t1: {
            fontSize: "30px",
            fontWeight: "700",
        },
        t2: {
            fontSize: "24px",
            fontWeight: "600",
        },
        t3: {
            fontSize: "20px",
            fontWeight: "600",
        },
        c1: {
            fontSize: "16px",
            fontWeight: "600",
        },
        c2: {
            fontSize: "15px",
            fontWeight: "400",
        },
        c3: {
            fontSize: "13px",
            fontWeight: "400",
        },
        c4: {
            fontSize: "12px",
            fontWeight: "600",
        },
        c5: {
            fontSize: "11px",
            fontWeight: "100",
        },
    },
    color: {
        gray50: "#f9fafb",
        gray100: "#f3f4f6",
        gray150: "#EDEDED",
        gray200: "#E6E6E9",
        gray250: "#E7E6E9",
        gray400: "#9DA6AF",
        gray450: "#6C757D",
        gray500: "#6A7581",
        gray500_007: "rgba(106, 117, 129, 0.07)",
        gray700: "#374151",
        gray800: "#2E3338",
        gray800_01: "rgba(46, 51, 56, 0.1)",
        zinc25: "#fcfcfc",
        zinc50: "#F0F0F0",
        zinc100: "#F3F3F3",
        zinc150: "#F4F4F4",
        zinc250: "#D9D9D9",
        zinc300: "#DDDDDD",
        zinc350: "#dcdcdc",
        zinc850: "#171A1C",
        zinc900: "#1C1C1C",
        black: "#000",
        black_05: "rgba(0, 0, 0, 0.5)",
        black_03: "rgba(0, 0, 0, 0.3)",
        black_025: "rgba(0, 0, 0, 0.25)",
        black_015: "rgba(0, 0, 0, 0.15)",
        black_01: "rgba(0, 0, 0, 0.1)",
        black_006: "rgba(0, 0, 0, 0.06)",
        neutral100: "#F6F6F6",
        neutral100_01: "rgba(246, 246, 246, 0.1)",
        neutral200: "#E6E6E6",
        neutral300: "#C7CCD1",
        neutral400: "#9E9E9E",
        neutral500: "#6D6D6D",
        neutral600: "#555555",
        neutral700: "#33373C",
        white: "#FFF",
        white_01: "rgba(255, 255, 255, 0.1)",
        white_03: "rgba(255, 255, 255, 0.3)",
        white_05: "rgba(255, 255, 255, 0.5)",
        white_07: "rgba(255, 255, 255, 0.7)",
        indigo400: "#8884D8",
        indigo450: "#6A5AF9",
        indigo500: "#6250FC",
        indigo500_01: "rgba(98, 80, 252, 0.1)",
        indigo500_007: "rgba(98, 80, 252, 0.07)",
        indigo500_005: "rgba(98, 80, 252, 0.05)",
        indigo550: "#5C4BED",
        indigo600: "#503FE4",
        indigo700: "#4434CC",
        indigo800: "#5044A7",
        indigo800_007: "rgba(80, 68, 167, 0.07)",
        cyan500: "#15B1C8",
        cyan500_01: "rgba(21, 177, 200, 0.1)",
        cyan600_007: "rgba(9, 140, 184, 0.07)",
        cyan700: "#008599",
        cyan700_01: "rgba(0, 133, 153, 0.1)",
        red400_01: "rgba(255, 126, 92, 0.1)",
        red500_01: "rgba(255, 99, 58, 0.1)",
        red500_007: "rgba(255, 99, 58, 0.07)",
        rose400: "#FF6B81",
        rose500: "#F93C65",
        rose500_01: "rgba(249, 60, 101, 0.1)",
        rose500_007: "rgba(249, 60, 101, 0.07)",
        orange500: "#FF7E5C",
        orange600: "#FF633A",
        blue600: "#007BFF",
        teal500: "#00B69B",
        teal500_01: "rgba(0, 182, 155, 0.1)",
        teal500_007: "rgba(0, 182, 155, 0.07)",
        teal600: "#009680",
        teal600_007: "rgba(0, 150, 128, 0.07)",
        sky800: "#006384",
        green600: "#05AE54",
        slate100: "#F1F3F8",
        stone50: "#F8F8F8",
        stone500: "#666",
        violet100: "#edebff",
        violet200: "#DCD8F3",
        violet300: "#CAC3EE",
        violet400: "#A89FE2",
        violet450: "#968BDD",
        violet500: "#8F6AFE",
    },
};
